import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { DefaultContextWidget } from '../_utils/asDefaultWidget/DefaultContextWidget';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { AttributeGroupActivityBlock } from '../../_blocks/AttributeGroupActivity';

export type AttributeGroupActivityWidget = ContextWidget<
  AttributeGroupActivityBlock,
  WidgetType.attributegroupactivity
>;

export function AttributeGroupActivityWidget(props: AttributeGroupActivityWidget) {
  const { t } = useSonTranslation('AttributeGroups');
  return <DefaultContextWidget icon={Icons.ACTIVITY} title={t('activity.widgetTitle')} {...props} />;
}
